const DEFAULT_TIME_ZONE = "America/Sao_Paulo";

function parseDate(value) {
  if (!value) return null;
  if (value instanceof Date) return value;

  const text = String(value);
  const hasTimeZone = /(?:z|[+-]\d{2}:?\d{2})$/i.test(text);
  const parsed = new Date(hasTimeZone ? text : `${text}Z`);

  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function getTimeZoneParts(date, timeZone = DEFAULT_TIME_ZONE) {
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  });

  return formatter.formatToParts(date).reduce((parts, part) => {
    if (part.type !== "literal") {
      parts[part.type] = part.value;
    }

    return parts;
  }, {});
}

function getTimeZoneOffsetMs(date, timeZone = DEFAULT_TIME_ZONE) {
  const parts = getTimeZoneParts(date, timeZone);
  const asUtc = Date.UTC(
    Number(parts.year),
    Number(parts.month) - 1,
    Number(parts.day),
    Number(parts.hour),
    Number(parts.minute),
    Number(parts.second)
  );

  return asUtc - date.getTime();
}

export function formatDateTime(value) {
  const parsed = parseDate(value);
  if (!parsed) return value || "-";

  return parsed.toLocaleString("pt-BR", {
    timeZone: DEFAULT_TIME_ZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function toDateTimeLocalInput(value, timeZone = DEFAULT_TIME_ZONE) {
  const parsed = parseDate(value);
  if (!parsed) return "";

  const parts = getTimeZoneParts(parsed, timeZone);
  return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}`;
}

export function fromDateTimeLocalInput(value, timeZone = DEFAULT_TIME_ZONE) {
  if (!value) return null;

  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/);
  if (!match) return null;

  const [, year, month, day, hour, minute] = match;
  const localAsUtc = Date.UTC(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    0
  );
  let utc = localAsUtc - getTimeZoneOffsetMs(new Date(localAsUtc), timeZone);
  utc = localAsUtc - getTimeZoneOffsetMs(new Date(utc), timeZone);

  return new Date(utc).toISOString();
}

export function formatDuration(ms) {
  if (ms === null || ms === undefined) return "-";
  if (ms < 1000) return `${ms} ms`;
  return `${(ms / 1000).toFixed(1)} s`;
}

export function errorMessage(error, fallback = "Não foi possível concluir a operação.") {
  return error?.response?.data?.message || error?.response?.data?.detail || error?.response?.data?.title || error?.message || fallback;
}

export function methodClass(method) {
  if (method === "Get") return "bg-sky-50 text-sky-700 border-sky-200";
  if (method === "Post") return "bg-emerald-50 text-emerald-700 border-emerald-200";
  if (method === "Put" || method === "Patch") return "bg-amber-50 text-amber-700 border-amber-200";
  if (method === "Delete") return "bg-red-50 text-red-700 border-red-200";
  return "bg-slate-50 text-slate-700 border-slate-200";
}
